import { UserFacingError } from './errors'

export type ConflictingHunt = {
  id: string
  title: string
  huntDate: string
  timePeriod: 'am' | 'midday' | 'pm' | 'all-day'
  creatorName: string
}

export class HuntConflictError extends UserFacingError {
  readonly conflicts: ConflictingHunt[]

  constructor(message?: string, conflicts: ConflictingHunt[] = []) {
    super(message ?? 'A hunt already exists for this date and location')
    this.name = 'HuntConflictError'
    this.conflicts = conflicts
  }
}

export class HuntNotFoundError extends UserFacingError {
  constructor() {
    super('Hunt not found')
    this.name = 'HuntNotFoundError'
  }
}

export class TooManyPhotosError extends UserFacingError {
  constructor() {
    super('Too many photos')
    this.name = 'TooManyPhotosError'
  }
}

export class MinimumParticipantsError extends UserFacingError {
  constructor() {
    super('At least one hunter required')
    this.name = 'MinimumParticipantsError'
  }
}

export class ZoneRequiredError extends UserFacingError {
  constructor() {
    super('Zone is required')
    this.name = 'ZoneRequiredError'
  }
}

export class HuntPhotoUploadFailedError extends UserFacingError {
  constructor() {
    super("Couldn't upload this photo")
    this.name = 'HuntPhotoUploadFailedError'
  }
}
